var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLicesesTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 34,
    height: 34,
    rx: 7,
    fill: "#334456",
    stroke: "#334456",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 18C17.436 18 16.9617 17.8077 16.577 17.423C16.1923 17.0383 16 16.564 16 16C16 15.436 16.1923 14.9617 16.577 14.577C16.9617 14.1923 17.436 14 18 14C18.564 14 19.0383 14.1923 19.423 14.577C19.8077 14.9617 20 15.436 20 16C20 16.564 19.8077 17.0383 19.423 17.423C19.0383 17.8077 18.564 18 18 18ZM18 25.962L14.037 27.146C13.7803 27.2373 13.5433 27.2007 13.326 27.036C13.1087 26.87 13 26.6493 13 26.374V20.87C12.3667 20.2473 11.875 19.5167 11.525 18.678C11.175 17.8393 11 16.9467 11 16C11 14.046 11.6777 12.3907 13.033 11.034C14.389 9.678 16.0437 9 17.997 9C19.9503 9 21.6057 9.678 22.963 11.034C24.321 12.3913 25 14.0467 25 16C25 16.9467 24.825 17.8397 24.475 18.679C24.125 19.5177 23.6333 20.248 23 20.87V26.374C23 26.6493 22.8913 26.8693 22.674 27.034C22.4567 27.1993 22.22 27.2363 21.964 27.145L18 25.962ZM18 22C19.6667 22 21.0833 21.4167 22.25 20.25C23.4167 19.0833 24 17.6667 24 16C24 14.3333 23.4167 12.9167 22.25 11.75C21.0833 10.5833 19.6667 10 18 10C16.3333 10 14.9167 10.5833 13.75 11.75C12.5833 12.9167 12 14.3333 12 16C12 17.6667 12.5833 19.0833 13.75 20.25C14.9167 21.4167 16.3333 22 18 22Z",
    fill: "#FFF7E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicesesTwo);
export default __webpack_public_path__ + "static/media/liceses_two.d532ff8898e3886b8c334712911a71f2.svg";
export { ForwardRef as ReactComponent };